import { create } from "zustand";

interface StoreState {
  unreachable: boolean;
}

interface StoreActions {
  setUnreachable: (unreachable: boolean) => void;
}

// QueryCache/MutationCache write this via getState() outside React (D-03);
// ServerRecovery and the route error page read it.
const useServerStore = create<StoreState & StoreActions>()((set) => ({
  unreachable: false,
  setUnreachable: (unreachable: boolean) =>
    set((state) => (state.unreachable === unreachable ? state : { unreachable })),
}));

export default useServerStore;
